<main id="content" role="main">
  <!-- Hero Section -->
  <div id="SVGHero" class="gradient-overlay-half-indigo-v1 position-relative overflow-hidden" style="">
    <div class="container space-2 space-top-md-5 space-top-lg-4">
      <div class="w-lg-60 text-center mx-lg-auto">
        <div class="mb-5">
          <h1 class="display-4 font-size-md-down-5 font-weight-medium mb-3">Delight your attendees and simplify your planning </h1>
          <h4>The conference ecosystem you have been missing!</h4>

        </div>
        <button class="btn btn-soft-indigo btn-wide transition-3d-hover" type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">
          Contact Sales
          <small class="fas fa-arrow-right ml-2"></small>
        </button>
        <small class="d-block d-sm-inline-block text-muted my-3 my-sm-0 mx-sm-3">or</small>
        <a class="btn btn-primary btn-wide transition-3d-hover" href="#">See Pricing</a>
      </div>
    </div>

    <!-- Mockup -->
    <div class="container space-2">
      <div class="position-relative w-lg-75 text-center mx-lg-auto">
        <div class="position-relative shadow-lg z-index-2 rounded-lg">
          <img class="img-fluid rounded-lg" src="../../assets/website/screenshots.gif" alt="Image Description">
        </div>

        <figure class="max-width-15 w-100 position-absolute top-0 right-0">
          <div class="mt-n11 mr-n11">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 458 458" style="enable-background:new 0 0 458 458;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">
<style type="text/css">
	.dots {
    fill: #2D1582;
  }
</style>
              <circle class="dots fill-indigo" cx="4" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="454" r="4"></circle>
</svg>
          </div>
        </figure>
        <figure class="max-width-15 w-100 position-absolute bottom-0 left-0">
          <div class="mb-n7 ml-n7">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 458 458" style="enable-background:new 0 0 458 458;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">
<style type="text/css">
	.dots {
    fill: #2D1582;
  }
</style>
              <circle class="dots fill-indigo" cx="4" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="4" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="94" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="184" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="274" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="364" r="4"></circle>
              <circle class="dots fill-indigo" cx="4" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="94" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="184" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="274" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="364" cy="454" r="4"></circle>
              <circle class="dots fill-indigo" cx="454" cy="454" r="4"></circle>
</svg>
          </div>
        </figure>
      </div>
    </div>
    <!-- End Mockup -->

    <!-- SVG Background Shape -->
    <figure class="ie-half-circle-1-1 w-35 position-absolute top-0 right-0 z-index-n1 mt-n11 mr-n11">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 902" style="enable-background:new 0 0 451 902;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">
<style type="text/css">
	.half-circle-1-0 {
    fill: none;
    stroke: #FFFFFF;
  }
</style>
        <path class="half-circle-1-0 fill-none stroke-white" stroke-width="164" stroke-miterlimit="10" d="M451,820C247.2,820,82,654.8,82,451S247.2,82,451,82"></path>
</svg>
    </figure>

    <figure class="ie-half-circle-2-1 w-25 position-absolute bottom-0 left-0 z-index-n1 mb-n11 ml-n11">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 902" style="enable-background:new 0 0 451 902;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">
<linearGradient id="halfCircledID_1" gradientUnits="userSpaceOnUse" x1="323.2045" y1="118.7578" x2="-97.6164" y2="847.6411" gradientTransform="matrix(1 0 0 -1 0 904)">
	<stop class="stop-color-white" offset="0" style="stop-color:#FFFFFF;stop-opacity:0"></stop>
  <stop class="stop-color-indigo" offset="1" style="stop-color:#2D1582"></stop>
</linearGradient>
        <path fill="none" opacity=".125" stroke="url(#halfCircledID_1)" stroke-width="164" stroke-miterlimit="10" d="M0,82c203.8,0,369,165.2,369,369S203.8,820,0,820"></path>
</svg>
    </figure>
    <!-- End SVG Background Shape -->
  </div>
  <!-- End Hero Section -->

  <div class="container space-1">
    <div class="row justify-content-lg-between">


      <div class="col-lg-12">
        <div class="row">
          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon33" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-money-check-edit-alt home-icon-theme"></i>
            </figure>
            <h4 class="h5">Registration</h4>
            <p class="font-size-1">Immediately following a live event, the talk will be on-demand for anyone who missed it or wants to watch again.</p>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon122s8" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-mobile home-icon-theme"></i>
            </figure>
            <h4 class="h5">Mobile App</h4>
            <p class="font-size-1">Completely customize your mobile app theme, colors and widgets using our interactive design tools!</p>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon29" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-booth-curtain home-icon-theme"></i>
            </figure>
            <h4 class="h5">Sponsor Portal & Booth Picker</h4>
            <p class="font-size-1">Manage your sponsors with a custom storefront! Interactive booth picker, asset and deadline management!</p>
            <!-- End Icon Blocks -->
          </div>



          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon230" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-browser home-icon-theme"></i>
            </figure>
            <h4 class="h5">Custom Website Builder</h4>
            <p class="font-size-1">Completely customize your conference website with our large set of widgets!</p>
            <!-- End Icon Blocks -->
          </div>
          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icona28" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-tasks-alt home-icon-theme"></i>
            </figure>
            <h4 class="h5">Abstract Management</h4>
            <p class="font-size-1">Create a call for abstracts usign our feature-packed tool. Email speakers, add internal notes, approve and reject abstracts and more!</p>
            <!-- End Icon Blocks -->
          </div>
          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon2813" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-megaphone home-icon-theme"></i>
            </figure>
            <h4 class="h5">Messaging</h4>
            <p class="font-size-1">Create custom lists based on virtually any criteria and send speakers, sponsors and attendees custom emails and push notifications using our feature packed email builder.</p>
            <!-- End Icon Blocks -->
          </div>
          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon32" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-calendar-alt home-icon-theme"></i>
            </figure>
            <h4 class="h5">Drag & Drop Scheduler</h4>
            <p class="font-size-1">Simplify your session planning with our drag and drop scheduler. Easily visualize each day and room and drag-n-drop to move sessions around</p>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon34" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-id-card-alt home-icon-theme"></i>
            </figure>
            <h4 class="h5">Check-in and Badge Printing</h4>
            <p class="font-size-1">Immediately following a live event, the talk will be on-demand for anyone who missed it or wants to watch again.</p>
            <!-- End Icon Blocks -->
          </div>
          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon28aw" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-hotel home-icon-theme"></i>
            </figure>
            <h4 class="h5">Presenter Expense and Hotel Room Tracking</h4>
            <p class="font-size-1">Manage your room blocks and pay presenters directly through our platform. We handle all the taxes and regulations so you don't have to!</p>
            <!-- End Icon Blocks -->
          </div>
          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon2865" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-poll-people home-icon-theme"></i>
            </figure>
            <h4 class="h5">Survey Builder</h4>
            <p class="font-size-1">User our beautiful survey builder to embed in registration forms or send at the end of a conference for attendee feedback!</p>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon11128" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-signal-stream home-icon-theme"></i>
            </figure>
            <h4 class="h5">Webinars and Live Streaming</h4>
            <p class="font-size-1">View live streams and run webinars right from the platform with no 3rd party tools. Track attendance and issue CEUs!</p>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon36" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-tasks home-icon-theme"></i>
            </figure>
            <h4 class="h5">Task Manager</h4>
            <p class="font-size-1">Collaborate with your team on the planning and execution of your conference using our robust task planner module!</p>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon26" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-qrcode home-icon-theme"></i>
            </figure>
            <h4 class="h5 text-center">CEU and Attendance tracking</h4>

            <p class="font-size-1">Physical attendees can scan a QR code in the room. Online attendees click "I'm here" and all their CEUs are combined in a single place.</p>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon27" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-tools home-icon-theme"></i>
            </figure>
            <h4 class="h5">Presenter Tools</h4>
            <p class="font-size-1">Live & virtual speakers can access ALL of the online tools. Chat, polls, handouts, questions...even standing at the podium!</p>
            <!-- End Icon Blocks -->
          </div>

          <!--          <div class="w-100"></div>-->

          <div class="col-sm-3 mt-4 mb-sm-0 text-center">
            <!-- Icon Blocks -->
            <figure id="icon25" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-closed-captioning home-icon-theme"></i>
            </figure>
            <h4 class="h5">Live Captioning</h4>
            <p class="font-size-1">Reduce your interpeter costs by embedding, in real-time, live captions into the stream translated to any language!</p>
            <!-- End Icon Blocks -->
          </div>

          <div class="col-sm-3 mt-4 text-center">
            <!-- Icon Blocks -->
            <figure id="icon2878" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
              <i class="fad fa-tv-alt home-icon-theme"></i>
            </figure>
            <h4 class="h5">Instant On-Demand Access</h4>
            <p class="font-size-1">Immediately following a live event, the talk will be on-demand for anyone who missed it or wants to watch again.</p>
            <!-- End Icon Blocks -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container space-1  ">
    <div class="w-lg-60 text-center mx-lg-auto">


      <button class="btn btn-primary btn-wide transition-3d-hover"  type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Book a Demo</button>
    </div>
  </div>

  <!-- Clients Section -->
<!--  <div class="container space-1">-->
<!--    <div class="w-lg-75 mx-lg-auto">-->
<!--      <div class="text-center mb-4">-->
<!--        <h2 class="u-divider u-divider&#45;&#45;text">Trusted by the world's best</h2>-->
<!--      </div>-->

<!--      <div class="row justify-content-between text-center">-->
<!--        <div class="col-4 col-lg-2 mb-5 mb-lg-0">-->
<!--          <div class="mx-4">-->
<!--            <img class="u-clients" src="../../assets/svg/clients-logo/amazon.svg" alt="Image Description">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-4 col-lg-2 mb-5 mb-lg-0">-->
<!--          <div class="mx-4">-->
<!--            <img class="u-clients" src="../../assets/svg/clients-logo/netflix.svg" alt="Image Description">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-4 col-lg-2 mb-5 mb-lg-0">-->
<!--          <div class="mx-4">-->
<!--            <img class="u-clients" src="../../assets/svg/clients-logo/paypal.svg" alt="Image Description">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-4 col-lg-2">-->
<!--          <div class="mx-4">-->
<!--            <img class="u-clients" src="../../assets/svg/clients-logo/slack.svg" alt="Image Description">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-4 col-lg-2">-->
<!--          <div class="mx-4">-->
<!--            <img class="u-clients" src="../../assets/svg/clients-logo/samsung.svg" alt="Image Description">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-4 col-lg-2">-->
<!--          <div class="mx-4">-->
<!--            <img class="u-clients" src="../../assets/svg/clients-logo/stripe.svg" alt="Image Description">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <!-- End Clients Section -->

  <!-- Features Section -->

  <!-- Features Section -->
  <div class="container space-2 space-top-lg-3">
    <div class="row justify-content-lg-between align-items-lg-center">
      <div class="col-lg-5 mb-9 mb-lg-0">
        <div class="mb-5">
          <h2 class="font-weight-medium mb-4">A Conference Companion In your Pocket</h2>
          <p>Take your conference engagement to the next level with our app, fostering collaboration and meaningful interactions.</p>
        </div>
        <ul class="list-unstyled">
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Attendee Chat</p>
            </div>
          </li>
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Conference Schedule</p>
            </div>
          </li>
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Sponsor Lead retrieval</p>
            </div>
          </li>
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Push Notifications</p>
            </div>
          </li>
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Complete Customization</p>
            </div>
          </li>
        </ul>

      </div>

      <div class="col-lg-6">
        <div id="featuresSVG" class=" position-relative max-width-50 mx-auto">
          <!-- SVG Phone Mockup -->
          <div class="w-75 u-devices-v2__phone-svg shadow-sm mx-auto">
            <figure class="ie-iphone-x-1">
              <img class="img-fluid" src="../../assets/website/iphone-screenshot-1.png" alt="Image Description"
                   data-img-paths='[
                   {"targetId": "#SVGiphoneX1Img1", "newPath": "../../assets/website/iphone-screenshot-1.png"}
                 ]'
                   data-parent="#featuresSVG">
            </figure>
          </div>
          <!-- End SVG Phone Mockup -->

          <!-- SVG Component -->
          <div class="position-absolute bottom-0 right-0 max-width-50 w-100 z-index-n1 mx-auto">
            <figure class="ie-abstract-shapes-12">
              <img class="js-svg-injector" src="../../assets/svg/components/abstract-shapes-12.svg" alt="Image Description"
                   data-parent="#featuresSVG">
            </figure>
          </div>
          <!-- End SVG Component -->
        </div>
      </div>
    </div>
  </div>
  <!-- End Features Section -->

  <!-- CTA Section -->
  <div class="container">
    <div class="w-lg-85 mx-lg-auto">
      <div id="SVGCTA" class="card border-0 shadow overflow-hidden p-5" style="">
        <div class="row justify-content-md-start align-items-md-center text-center text-md-left">
          <div class="col-md-8 col-lg-5 offset-lg-3 mb-3 mb-md-0">
            <h3 class="h4 text-indigo font-weight-medium mb-0">Revolutionizing the way you plan conferences!</h3>
          </div>

          <div class="col-md-4 text-md-right">
            <button class="btn btn-primary transition-3d-hover"  type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Book a demo</button>
          </div>
        </div>

        <!-- SVG Component -->
        <figure class="ie-half-circle-2-2 w-35 position-absolute top-0 left-0 mt-n11 ml-n11">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 902" style="enable-background:new 0 0 451 902;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGCTA">
<linearGradient id="halfCircledID_1" gradientUnits="userSpaceOnUse" x1="323.2045" y1="118.7578" x2="-97.6164" y2="847.6411" gradientTransform="matrix(1 0 0 -1 0 904)">
	<stop class="stop-color-white" offset="0" style="stop-color:#FFFFFF;stop-opacity:0"></stop>
  <stop class="stop-color-indigo" offset="1" style="stop-color:#2D1582"></stop>
</linearGradient>
            <path fill="none" opacity=".125" stroke="url(#halfCircledID_1)" stroke-width="164" stroke-miterlimit="10" d="M0,82c203.8,0,369,165.2,369,369S203.8,820,0,820"></path>
</svg>
        </figure>
        <!-- End SVG Component -->
      </div>
    </div>
  </div>
  <!-- End CTA Section -->

  <!-- Features Section -->
<!--  <div class="container space-2 space-lg-3">-->
<!--    <div class="row align-items-lg-center">-->
<!--      <div class="col-lg-5 mb-7 mb-lg-0">-->
<!--        <div class="mb-5">-->
<!--          <h2 class="font-weight-medium">The best software teams ship early and often.</h2>-->
<!--          <p>Front Software is built for every member of your software team to plan, track, and release great software.</p>-->
<!--        </div>-->

<!--        &lt;!&ndash; Info &ndash;&gt;-->
<!--        <ul class="list-unstyled">-->
<!--          <li class="media pb-3">-->
<!--              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-4">-->
<!--                <span class="fas fa-check btn-icon__inner"></span>-->
<!--              </span>-->
<!--            <div class="media-body">-->
<!--              <p class="text-dark mb-0">Knowledge management</p>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li class="media py-3">-->
<!--              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-4">-->
<!--                <span class="fas fa-check btn-icon__inner"></span>-->
<!--              </span>-->
<!--            <div class="media-body">-->
<!--              <p class="text-dark mb-0">Development workflow</p>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li class="media pt-3">-->
<!--              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-4">-->
<!--                <span class="fas fa-check btn-icon__inner"></span>-->
<!--              </span>-->
<!--            <div class="media-body">-->
<!--              <p class="text-dark mb-0">Continuous integration</p>-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul>-->
<!--        &lt;!&ndash; End Info &ndash;&gt;-->
<!--      </div>-->

<!--      <div class="col-lg-7">-->
<!--        &lt;!&ndash; Card Block &ndash;&gt;-->
<!--        <div id="featuresSVG2" class="pl-lg-4" style="">-->
<!--          <div class="card border-0 bg-soft-info text-indigo text-center w-lg-75 overflow-hidden pt-9 px-5 mx-lg-auto">-->
<!--            <div class="px-5 mb-5">-->
<!--              <h3 class="h6">Integrate with the tools and workflow you already use</h3>-->
<!--            </div>-->

<!--            &lt;!&ndash; SVG Phone Mockup &ndash;&gt;-->
<!--            <div class="w-85 u-devices-v2__phone-svg shadow-sm mx-auto">-->
<!--              <figure class="ie-half-iphone-x-1-iphone">-->
<!--                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.4 494" style="enable-background:new 0 0 443.4 494;" xml:space="preserve" class="injected-svg js-svg-injector" data-img-paths="[-->
<!--                         {&quot;targetId&quot;: &quot;#SVGhalfIphoneX1Img1&quot;, &quot;newPath&quot;: &quot;../../assets/img/407x472/img2.jpg&quot;}-->
<!--                       ]" data-parent="#featuresSVG2">-->
<!--<style type="text/css">-->
<!--	.half-iphone-x-1-0 {-->
<!--    fill: #FFFFFF;-->
<!--  }-->

<!--  .half-iphone-x-1-1 {-->
<!--    fill: none;-->
<!--    stroke: #F7F7F7;-->
<!--  }-->

<!--  .half-iphone-x-1-2 {-->
<!--    fill: none;-->
<!--    stroke: #E7EAF3;-->
<!--  }-->

<!--  .half-iphone-x-1-3 {-->
<!--    fill: none;-->
<!--  }-->
<!--</style>-->
<!--                  <path class="half-iphone-x-1-0" d="M443.4,494V65.1c0-36-29.2-65.1-65.1-65.1H65.1C29.1,0,0,29.1,0,65.1V494"></path>-->
<!--                  <path class="half-iphone-x-1-1" stroke-width="4" stroke-miterlimit="10" d="M242.8,36.8h-46.4c-2,0-3.6-1.6-3.6-3.6l0,0c0-2,1.6-3.6,3.6-3.6h46.4c2,0,3.6,1.6,3.6,3.6l0,0  C246.4,35.2,244.8,36.8,242.8,36.8z"></path>-->
<!--                  <circle class="half-iphone-x-1-1" stroke-width="4" stroke-miterlimit="10" cx="269.5" cy="33.2" r="5.5"></circle>-->
<!--                  <g>-->
<!--	<defs>-->
<!--		<path id="halfIphoneX1ID2" d="M18.6,494V73.6c0-28,21.8-50.7,48.8-50.7h35.3c4,0,7.2,3.4,7.2,7.5l0,0c0,14.9,11.6,27,26,27h171.5    c14.4,0.1,26-12,26-27l0,0c0-4.1,3.2-7.5,7.2-7.5H376c26.9,0,48.8,22.7,48.8,50.7V494"></path>-->
<!--	</defs>-->
<!--                    <clipPath id="halfIphoneX1ID1">-->
<!--		<use xlink:href="#halfIphoneX1ID2" style="overflow:visible;"></use>-->
<!--	</clipPath>-->
<!--                    <g style="clip-path:url(#halfIphoneX1ID1);">-->
<!--		<image id="SVGhalfIphoneX1Img1" style="overflow:visible;" width="407" height="472" xlink:href="../../assets/img/407x472/img2.jpg" transform="matrix(1 0 0 1 18.2 22.45)"></image>-->
<!--	</g>-->
<!--</g>-->
<!--                  <path class="half-iphone-x-1-2" stroke-miterlimit="10" d="M18.6,494V73.6c0-28,21.8-50.7,48.8-50.7h35.3c4,0,7.2,3.4,7.2,7.5l0,0c0,14.9,11.6,27,26,27h171.5  c14.4,0.1,26-12,26-27l0,0c0-4.1,3.2-7.5,7.2-7.5H376c26.9,0,48.8,22.7,48.8,50.7V494"></path>-->
<!--                  <rect class="half-iphone-x-1-3" width="443.4" height="494"></rect>-->
<!--</svg>-->
<!--              </figure>-->
<!--            </div>-->
<!--            &lt;!&ndash; End SVG Phone Mockup &ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; End Card Block &ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <!-- End Features Section -->

  <!-- Icons Section -->
<!--  <div class="position-relative gradient-overlay-half-primary-v3 overflow-hidden">-->
<!--    <div class="container space-top-2 space-top-lg-3">-->
<!--      &lt;!&ndash; Title &ndash;&gt;-->
<!--      <div class="w-md-80 w-lg-50 text-center mx-md-auto mb-9">-->
<!--        <h2 class="text-white font-weight-medium">Go Front with ease.</h2>-->
<!--        <p class="text-white-70">Whether you’re a seasoned agile expert, or just getting started, Jira Software unlocks the power of agile.</p>-->
<!--      </div>-->
<!--      &lt;!&ndash; End Title &ndash;&gt;-->

<!--      &lt;!&ndash; Icon Blocks &ndash;&gt;-->
<!--      <div class="w-lg-80 mx-lg-auto mb-11">-->
<!--        <div class="row mb-9">-->
<!--          <div class="col-6 col-md-4 mb-7">-->
<!--            &lt;!&ndash; Icon Block &ndash;&gt;-->
<!--            <span class="d-block text-white font-size-2 mb-3">-->
<!--                <span class="fas fa-align-center"></span>-->
<!--              </span>-->
<!--            <h4 class="h6 text-white font-weight-semi-bold mb-3">Flexible planning</h4>-->
<!--            <p class="text-white-70">Front Software's rich planning features enable your team to flexibly plan.</p>-->
<!--            &lt;!&ndash; End Icon Block &ndash;&gt;-->
<!--          </div>-->

<!--          <div class="col-6 col-md-4 mb-7">-->
<!--            &lt;!&ndash; Icon Block &ndash;&gt;-->
<!--            <span class="d-block text-white font-size-2 mb-3">-->
<!--                <span class="fas fa-code-branch"></span>-->
<!--              </span>-->
<!--            <h4 class="h6 text-white font-weight-semi-bold mb-3">Accurate estimations</h4>-->
<!--            <p class="text-white-70">Use story points, hours, t-shirt sizes, or your own estimation technique.</p>-->
<!--            &lt;!&ndash; End Icon Block &ndash;&gt;-->
<!--          </div>-->

<!--          <div class="col-6 col-md-4 mb-7 mb-md-0">-->
<!--            &lt;!&ndash; Icon Block &ndash;&gt;-->
<!--            <span class="d-block text-white font-size-2 mb-3">-->
<!--                <span class="fas fa-shapes"></span>-->
<!--              </span>-->
<!--            <h4 class="h6 text-white font-weight-semi-bold mb-3">Value-driven prioritization</h4>-->
<!--            <p class="text-white-70">Order user stories, issues, and bugs in your product backlog with simple dragging.</p>-->
<!--            &lt;!&ndash; End Icon Block &ndash;&gt;-->
<!--          </div>-->

<!--          <div class="col-6 col-md-4 mb-7 mb-md-0">-->
<!--            &lt;!&ndash; Icon Block &ndash;&gt;-->
<!--            <span class="d-block text-white font-size-2 mb-3">-->
<!--                <span class="fas fa-clone"></span>-->
<!--              </span>-->
<!--            <h4 class="h6 text-white font-weight-semi-bold mb-3">Transparent execution</h4>-->
<!--            <p class="text-white-70">Front Software brings a new level of transparency to your team's work.</p>-->
<!--            &lt;!&ndash; End Icon Block &ndash;&gt;-->
<!--          </div>-->

<!--          <div class="col-6 col-md-4">-->
<!--            &lt;!&ndash; Icon Block &ndash;&gt;-->
<!--            <span class="d-block text-white font-size-2 mb-3">-->
<!--                <span class="fas fa-check-circle"></span>-->
<!--              </span>-->
<!--            <h4 class="h6 text-white font-weight-semi-bold mb-3">Actionable results</h4>-->
<!--            <p class="text-white-70">Extensive reporting functionality gives your team critical insight into their agile process.</p>-->
<!--            &lt;!&ndash; End Icon Block &ndash;&gt;-->
<!--          </div>-->

<!--          <div class="col-6 col-md-4">-->
<!--            &lt;!&ndash; Icon Block &ndash;&gt;-->
<!--            <span class="d-block text-white font-size-2 mb-3">-->
<!--                <span class="fas fa-compress"></span>-->
<!--              </span>-->
<!--            <h4 class="h6 text-white font-weight-semi-bold mb-3">Scalable evolution-->
<!--              <span class="badge badge-warning font-weight-medium badge-pill ml-1">Coming soon</span>-->
<!--            </h4>-->
<!--            <p class="text-white-70">Front Software is agile project management designed for any teams.</p>-->
<!--            &lt;!&ndash; End Icon Block &ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; Buttons &ndash;&gt;-->
<!--        <div class="text-center">-->
<!--          <div class="mb-3">-->
<!--            <a class="btn btn-sm btn-white btn-wide text-primary transition-3d-hover" href="#">Sign up and Start Building</a>-->
<!--            <small class="d-block d-sm-inline-block text-white-70 my-3 my-sm-0 mx-sm-3">or</small>-->
<!--            <a class="btn btn-sm btn-indigo btn-wide transition-3d-hover" href="#">Talk to our Experts</a>-->
<!--          </div>-->
<!--          <p class="small text-white-70">Start free trial. * No credit card required.</p>-->
<!--        </div>-->
<!--        &lt;!&ndash; End Buttons &ndash;&gt;-->
<!--      </div>-->
<!--      &lt;!&ndash; End Icon Blocks &ndash;&gt;-->

<!--      <div class="w-85 w-md-75 w-lg-65 text-center mx-auto">-->
<!--        <img class="img-fluid" src="../../assets/svg/illustrations/ai-creation.svg" alt="Image Description">-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash; SVG Background Shape &ndash;&gt;-->
<!--    <figure class="w-35 position-absolute top-0 right-0 z-index-n1">-->
<!--      <div class="mt-n11 mr-n11">-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 902" style="enable-background:new 0 0 451 902;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">-->
<!--<linearGradient id="halfCircle3ID1" gradientUnits="userSpaceOnUse" x1="225.5" y1="0" x2="225.5" y2="902">-->
<!--	<stop class="stop-color-primary" offset="1.385225e-07" style="stop-color:#377DFF;stop-opacity:15.000000e-02"></stop>-->
<!--  <stop class="stop-color-white" offset="0.6469" style="stop-color:#FFFFFF;stop-opacity:0"></stop>-->
<!--</linearGradient>-->
<!--          <path fill="none" stroke="url(#halfCircle3ID1)" stroke-width="164" stroke-miterlimit="10" d="M451,820C247.2,820,82,654.8,82,451S247.2,82,451,82"></path>-->
<!--</svg>-->
<!--      </div>-->
<!--    </figure>-->
<!--    <figure class="w-25 position-absolute bottom-0 left-0 z-index-n1">-->
<!--      <div class="mb-n11 ml-n11">-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 902" style="enable-background:new 0 0 451 902;" xml:space="preserve" class="injected-svg js-svg-injector" data-parent="#SVGHero">-->
<!--<linearGradient id="halfCircledID_1" gradientUnits="userSpaceOnUse" x1="323.2045" y1="118.7578" x2="-97.6164" y2="847.6411" gradientTransform="matrix(1 0 0 -1 0 904)">-->
<!--	<stop class="stop-color-white" offset="0" style="stop-color:#FFFFFF;stop-opacity:0"></stop>-->
<!--  <stop class="stop-color-indigo" offset="1" style="stop-color:#2D1582"></stop>-->
<!--</linearGradient>-->
<!--          <path fill="none" opacity=".125" stroke="url(#halfCircledID_1)" stroke-width="164" stroke-miterlimit="10" d="M0,82c203.8,0,369,165.2,369,369S203.8,820,0,820"></path>-->
<!--</svg>-->
<!--      </div>-->
<!--    </figure>-->
<!--    &lt;!&ndash; End SVG Background Shape &ndash;&gt;-->
<!--  </div>-->
  <!-- End Icons Section -->

  <!-- Pricing Section -->
  <div class="container space-1">
    <div >
      <h3>Pricing</h3>
    </div>

    <!-- Table -->
    <div class="table-responsive-lg">
      <table class="table table-striped table-borderless">
        <thead class="text-center">
        <tr>
          <th scope="col" class="w-40"></th>
          <th scope="col" class="w-20">
            Lite
            <small class="d-block text-secondary">$6/registrant</small>
            <small class="d-block text-secondary">$1,000 Minimum</small>
          </th>
          <th scope="col" class="w-20  border-left">
            Virtual
            <small class="d-block text-secondary">$15/registrant</small>
            <small class="d-block text-secondary">$3,500 Minimum</small>
          </th>
          <th scope="col" class="w-20 border-left">
            Hybrid
            <small class="d-block text-secondary">$25/registrant</small>
            <small class="d-block text-secondary">$10,000 Minimum</small>
            <small class="d-block ">All labor and equipment included</small>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr class="border-top border-bottom">
          <th scope="row" class="h6 bg-white pt-5 pb-3 px-4 mb-0">General</th>
          <td class="bg-white"></td>
          <td class="bg-white"></td>
          <td class="bg-white"></td>
          <!-- <td class="bg-white"></td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Included Days</th>
          <td class="text-muted text-center p-3"><span class="text-success">3</span><br /></td>
          <td class="text-muted text-center border-left p-3"><span class="text-success">1</span><br /></td>
          <td class="text-center text-muted border-left p-3"><span class="text-success">2</span><br /></td>
          <!-- <td class="text-muted text-center p-3"><span class="text-success">3</span><br /></td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Concurrent Sessions (tracks)</th>
          <td class="text-muted text-center p-3"><span class="text-success">2</span><br /></td>
          <td class="text-muted text-center border-left p-3"><span class="text-success">2</span><br /></td>
          <td class="text-center text-success border-left p-3">5</td>
          <!-- <td class="text-muted text-center p-3"><span class="text-success">3</span><br /></td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">
            Additional Tracks/Days
            <br />
            <span class="text-muted small">Priced by concurrent tracks (sessions) per day</span>
          </th>
          <td class="text-muted text-center p-3"><span class="text-success">$250</span>
            <span class="d-block text-muted small">Per day (unlimited tracks)</span>
          </td>
          <td class="text-muted text-center border-left p-3"><span class="text-success">$900</span>
            <span class="d-block text-muted small">Per track per day</span>
          </td>
          <td class="text-center text-success border-left p-3">$900
            <span class="d-block text-muted small">Per track per day</span>

          </td>
          <!-- <td class="text-muted text-center p-3"><span class="text-success">3</span><br /></td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Streaming
            <span class="d-block text-muted small">Cameras & Equipment included</span>
          </th>
          <td class="text-center text-danger p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-success  border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Abstract Management</th>
          <td class="text-center text-danger p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center  border-left text-success p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Mobile App</th>
          <td class="text-center text-success p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Custom Website & Registration</th>
          <td class="text-center text-success p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>

        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Sponsor Management</th>
          <td class="text-center text-danger p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Survey Tools</th>
          <td class="text-center text-danger p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-danger border-left p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>   <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Task Planner</th>
          <td class="text-center text-danger p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-danger border-left p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Presenter Expense Tracking</th>
          <td class="text-center text-danger p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-danger border-left p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Hotel Room Tracking</th>
          <td class="text-center text-danger p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-danger border-left p-3">
            <small class="fas fa-times"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>
        <tr class="border-top border-bottom">
          <th scope="row" class="h6 bg-white pt-5 pb-3 px-4 mb-0">CEU Issuance</th>
          <td class="bg-white"></td>
          <td class="bg-white " ></td>
          <td class="bg-white "></td>
          <!-- <td class="bg-white"></td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Online Attendance Checks</th>
          <td class="text-center text-secondary p-3">N/A</td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">QR Code Scan In/Out</th>
          <td class="text-center text-secondary p-3">N/A</td>
          <td class="text-center text-secondary border-left p-3">N/A</td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Combined CEU Certificate</th>
          <td class="text-center text-success p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <tr class="border-top border-bottom">
          <th scope="row" class="h6 bg-white pt-5 pb-3 px-4 mb-0">Streaming</th>
          <td class="bg-white"></td>
          <td class="bg-white " ></td>
          <td class="bg-white "></td>
          <!-- <td class="bg-white"></td> -->
        </tr>

        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">StreamBox</th>
          <td class="text-center text-secondary py-3 px-4">N/A</td>
          <td class="text-center text-secondary border-left py-3 px-4">N/A</td>
          <td class="text-center text-success border-left py-3 px-4">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">On-Demand Access</th>
          <td class="text-success text-center text-secondary p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-success text-center border-left text-secondary p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <tr class="border-top border-bottom">
          <th scope="row" class="h6 bg-white pt-5 pb-3 px-4 mb-0">Presenter Tools</th>
          <td class="bg-white"></td>
          <td class="bg-white " ></td>
          <td class="bg-white "></td>
          <!-- <td class="bg-white"></td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Questions</th>
          <td class="text-success text-center border-left text-secondary p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td>
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Polls</th>
          <td class="text-center text-success  p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Chat</th>
          <td class="text-center text-success p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Materials & Handouts</th>
          <td class="text-center text-success p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <tr>
          <th scope="row" class="font-size-1 font-weight-normal py-3 px-4">Embedded Videos</th>
          <td class="text-center text-success  p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <td class="text-center text-success border-left p-3">
            <small class="fas fa-check"></small>
          </td>
          <!-- <td class="text-success text-center p-3">
            <small class="fas fa-check"></small>
          </td> -->
        </tr>
        <!-- <tr>
          <th scope="row" class="bg-white p-3"></th>
          <td class="bg-white text-center p-3">
            <button type="button" class="btn btn-xs btn-soft-indigo transition-3d-hover">Choose Plan</button>
          </td>
          <td class="bg-white text-center border-left p-3">
            <button type="button" class="btn btn-xs btn-soft-indigo transition-3d-hover">Choose Plan</button>
          </td>
          <td class="bg-white text-center p-3">
            <button type="button" class="btn btn-xs btn-primary transition-3d-hover">Contact Us</button>
          </td>
        </tr> -->
        </tbody>
      </table>
    </div>
    <!-- End Table -->
  </div>
  <!-- End Pricing Section -->


  <div id="SVGelements" class="">
    <!-- SVG Background -->
    <figure class="position-absolute right-0 bottom-0 left-0">
      <img class="js-svg-injector" src="../../assets/svg/components/wave-1-bottom-sm.svg" alt="Image Description"
           data-parent="#SVGelements">
    </figure>
    <!-- End SVG Background -->

    <div class="gradient-half-primary-v3">
      <div class="container space-top-2 space-top-md-3 space-bottom-1">
        <div class="row justify-content-lg-between align-items-lg-start">
          <div class="col-lg-5 mb-7 mb-lg-0">
            <!-- Title -->
            <div class="pr-md-4 mb-4">
              <h2 class="text-primary">Let's get you <span class="font-weight-semi-bold">started</span></h2>
              <p>Partner with OkWhen and experience the difference that true full-service management delivers. Our seasoned team seamlessly handles every aspect of your event, allowing you to focus on what matters most—connecting with your audience and achieving your goals.</p>
            </div>
            <!-- End Title -->

            <button class="btn btn-soft-primary btn-wide btn-pill transition-3d-hover ml-1 mb-2" type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Get Started</button>
          </div>

          <div class="col-lg-6 mt-auto">
            <!-- SVG Icon -->
            <figure class="ie-working-men">
              <img class="js-svg-injector" src="../../assets/svg/illustrations/app-development.svg" alt="SVG Illustration"
                   data-parent="#SVGelements">
            </figure>
            <!-- End SVG Icon -->
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
